import React from 'react';
import { Grid } from '@mui/material';
import { PrimaryButton, Text } from 'library';
import { ITeacher } from 'models';
import TadaIcon from 'assets/icons/tandempay/tada-circle.svg';

export default function InviteSuccess({
    selectedWorkers,
    onClose,
}: {
    selectedWorkers: ITeacher[];
    onClose: () => void;
}) {
    const workerNames = selectedWorkers.map((w) => w.name);
    let names = '';
    if (workerNames.length > 2) {
        names = workerNames.slice(0, -1).join(', ') + ', and ' + workerNames.slice(-1);
    } else if (workerNames.length === 2) {
        names = workerNames.join(' and ');
    } else {
        names = workerNames[0];
    }

    return (
        <>
            <Grid container flexDirection="row" alignItems="center" justifyContent="flex-start">
                <TadaIcon style={styles.icon} />
                <Text variant="h1" textStyle={{ fontSize: 28 }}>
                    Success!
                </Text>
            </Grid>

            <Text variant="h2" textStyle={{ marginTop: 40 }}>
                We&apos;ve invited{' '}
                <Text variant="h2" bold inline>
                    {names}
                </Text>{' '}
                to your job.
            </Text>

            <Text variant="body1" textStyle={{ marginTop: 20 }}>
                We are checking to see if they are available. You will be notified and see them on your schedule if they
                accept.
            </Text>
            <Grid container flexDirection="column" justifyContent="flex-end" flex={1}>
                <Grid container gap={2} flexDirection="row" justifyContent="flex-end">
                    <PrimaryButton onClick={onClose} buttonStyle={{ width: 150 }}>
                        Done
                    </PrimaryButton>
                </Grid>
            </Grid>
        </>
    );
}

const styles = {
    icon: {
        width: 70,
        height: 70,
        marginRight: 23,
        borderRadius: '50%',
    },
};
